// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2H1xd","colMin":"styles_colMin__lmeG8","colCheckbox":"styles_colCheckbox__1hx3m"};